<template>
  <section id="uslugi" class="bg-graphite-50 py-20 sm:py-28">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <span class="section-label">Usługi</span>
        <h2 class="section-title">Pełen zakres obróbki metalu w jednym miejscu</h2>
        <p class="mt-5 text-base leading-relaxed text-graphite-600">
          Realizujemy zlecenia punktowe i kompleksowe — od pojedynczej usługi po pełny cykl
          produkcyjny gotowego elementu.
        </p>
      </div>

      <div class="mt-16 grid grid-cols-1 border-l border-t border-graphite-200 sm:grid-cols-2 lg:grid-cols-4">
        <div
            v-for="service in services"
            :key="service.title"
            class="group border-b border-r border-graphite-200 bg-white p-7 transition-colors hover:bg-graphite-900"
        >
          <div class="flex h-12 w-12 items-center justify-center border-2 border-brand-600 text-brand-600 transition-colors group-hover:border-white group-hover:text-white" v-html="service.icon"></div>
          <h3 class="mt-5 text-base font-bold text-graphite-900 transition-colors group-hover:text-white">{{ service.title }}</h3>
          <p class="mt-2 text-sm leading-relaxed text-graphite-500 transition-colors group-hover:text-graphite-300">{{ service.text }}</p>
          <span v-if="service.badge" class="mt-4 inline-block border border-graphite-300 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-graphite-500 transition-colors group-hover:border-brand-500 group-hover:text-brand-400">
            {{ service.badge }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection',
  data() {
    return {
      services: [
        {
          title: 'Projektowanie dla klienta',
          text: 'Indywidualne projekty CAD dopasowane do wymagań technicznych i funkcjonalnych zlecenia.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12M3 5.25V12m9-4.5l3 3m0 0l-3 3m3-3H8.25"/></svg>'
        },
        {
          title: 'Ślusarstwo',
          text: 'Precyzyjne prace ślusarskie, montaż i wykonanie elementów konstrukcyjnych na wymiar.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.909 4.909m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"/></svg>'
        },
        {
          title: 'Wypalanie akcesoriów',
          text: 'Precyzyjne wycinanie elementów laserem i plazmą według dokumentacji technicznej.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5"/></svg>'
        },
        {
          title: 'Cięcie blach',
          text: 'Cięcie blach w różnych grubościach i materiałach z dbałością o dokładność wymiarową.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>'
        },
        {
          title: 'Gięcie blach',
          text: 'Formowanie blach na prasach krawędziowych zgodnie z wymaganą geometrią elementu.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M4 19.5V6a2 2 0 012-2h8.5L20 8.5V19a2 2 0 01-2 2H6a2 2 0 01-2-2z"/><path stroke-linecap="round" stroke-linejoin="round" d="M9 13l3-3 3 3"/></svg>'
        },
        {
          title: 'Spawanie',
          text: 'Trwałe i estetyczne połączenia spawalnicze wykonywane przez doświadczonych spawaczy.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>'
        },
        {
          title: 'Malowanie natryskowe',
          text: 'Malowanie proszkowe i natryskowe zapewniające trwałość i estetykę powierzchni.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"/></svg>'
        },
        {
          title: 'Cynkowanie',
          text: 'Zabezpieczenie antykorozyjne realizowane we współpracy ze sprawdzonym partnerem zewnętrznym.',
          badge: 'z partnerem zewnętrznym',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"/></svg>'
        }
      ]
    };
  }
};
</script>
